import React from "react";
import { Outlet } from "react-router-dom";
import SteppedApplicationContainer from "../../pages/Application/SteppedApplicationContainer";

const ProductLayout = () => {
  return (
    <SteppedApplicationContainer>
      <Outlet />
    </SteppedApplicationContainer>
  );
};

export default ProductLayout;
